export const maxLimitPagination = 10;
export const maxContentText = 50;
export const maxSearchJobApplicant = 50;
